import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export abstract class SharedApiService {

  abstract getPublic<T>(path: string, params?: HttpParams, headers?: HttpHeaders): Observable<T>;

  abstract get<T>(path: string, params?: HttpParams, headers?: HttpHeaders): Observable<T>;

}
